import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUsersPlans } from '../services/api'; // Use your API file

export const getUsersPlans = createAsyncThunk('usersPlans/getUsersPlans', async () => {
    const response = await fetchUsersPlans(); // Pass reviewId if available
    return response.data;
});

const usersPlanSlice = createSlice({
    name: 'usersPlans',
    initialState: {
        usersPlans: [],  // Storing open calls here
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: {
        [getUsersPlans.pending]: (state) => {
            state.status = 'loading';
        },
        [getUsersPlans.fulfilled]: (state, action) => {
            state.usersPlans = action.payload.data;
            state.status = 'succeeded';
        },
        [getUsersPlans.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default usersPlanSlice.reducer;